



































import {Vue, Component, Watch} from 'vue-property-decorator';
import {Getter, Action} from 'vuex-class';
import {popupResize} from '@/utils/ncp';
import MemberInfo from '@/components/member/popup/memberCrm/MemberInfo.vue';
import MemberCrmNav from '@/components/member/popup/memberCrm/MemberCrmNav.vue';
import {GetMembersMemberNo} from 'supporter';

@Component({
  components: {
    MemberInfo,
    MemberCrmNav
  }
})
export default class Crm extends Vue {
  @Getter('memberCrm/memberInfoDetail') private memberInfoDetail!: GetMembersMemberNo;
  @Action('mall/fetchMalls') private fetchMalls!: Function;

  @Watch('$route', {immediate: true, deep: true})
  routeChange(next: any) {
    this.checkRoute(next);
  }

  @Watch('memberInfoDetail', {immediate: true, deep: true})
  memberInfoDetailChange(next: any) {
    if (this.memberInfoDetail.memberStatus === 'WITHDRAWN') {
        this.$router.push({name: 'MemberHasDetach'})
      }
  }

  private viewKey = 1;
  private showBenefit: any = '';
  private benefitActive: string = 'mileage';

  private created(): void {
    this.fetchMalls();
    document.body.classList.add('popup_large');
    this.$nextTick(() => {
      popupResize();
    });
  }

  private checkRoute(next: any): void {
    this.viewKey+=1;
    this.showBenefit = this.$route.name;
    if (!next) {
      this.benefitActive = 'mileage';
      return;
    }
    if (next.name !== 'MemberCrmBenefitDetail') {
      this.benefitActive = 'mileage';
    } else {
      this.benefitActive = 'coupon';
    }
  }
  private handleActive(tab: string): void {
    if (tab === 'coupon') {
      this.benefitActive = 'coupon';
    } else {
      this.benefitActive = 'mileage';
    }

    if (this.benefitActive === 'coupon'&&this.$route.name !=='MemberCrmBenefitDetail') {
      let memberNum: any = this.$route.params.memberId;
      this.$router.push(`/member/popup/crm/${memberNum}/benefitDetail`);
    }
    if (this.benefitActive === 'mileage'&&this.$route.name !=='MemberCrmBenefitDetailMileage') {
      let memberNum: any = this.$route.params.memberId;
      this.$router.push(`/member/popup/crm/${memberNum}/benefitDetailMileage`);
    }
  }
}
